var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('icon-link');
import { breakpoints, theme } from '@shapeable/theme';
import { useLink } from '../hooks/use-link';
import { IconLabel } from './icon-label';
import { Icon } from './icon';
import { useEnv } from '../hooks/use-env';
import { useComponentPropsFor } from '../context/component-props-context';
export var IconLinkDefaultProps = {
  reverse: false,
  iconSize: 20,
  colors: {
    fill: 'strong',
    text: 'strong',
    hover: {
      fill: 'primary',
      text: 'primary'
    }
  }
};
// -------- Styles -------->
var LabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    text-decoration: none;\n    user-select: none;\n    ", ";\n    ", "\n\n  "], ["\n    text-decoration: none;\n    user-select: none;\n    ", ";\n    ", "\n\n  "])), theme.APPLY_COLORS, function (_a) {
    var disabled = _a.disabled;
    return disabled && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      opacity: 0.2;\n      cursor: default;\n    "], ["\n      opacity: 0.2;\n      cursor: default;\n    "])));
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n    display: flex;\n  "], ["\n    ", ";\n    display: flex;\n  "])), LabelStyles)
});
// -------- Components -------->
var My = {
  NAME: 'IconLink',
  Label: styled(IconLabel)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Icon: styled(Icon)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  A: styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject([""], [""]))),
  Body: styled.span.attrs(cls.attr('body'))(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles)
};
export var IconLink = function (props) {
  var _a = useComponentPropsFor(My.NAME, IconLinkDefaultProps, props),
    className = _a.className,
    children = _a.children,
    reverse = _a.reverse,
    icon = _a.icon,
    iconSize = _a.iconSize,
    disabled = _a.disabled,
    colors = _a.colors,
    rest = __rest(_a, ["className", "children", "reverse", "icon", "iconSize", "disabled", "colors"]);
  var env = useEnv();
  var Link = useLink().Link;
  if (env.DEBUG_ICON_LINK) {
    console.log("ICON LINK PROPS", props);
  }
  var href = props.href;
  var hasLink = !disabled && !!href;
  var Container = hasLink ? Link : My.A;
  var containerProps = hasLink ? __assign({
    href: href
  }, rest) : {};
  // when rendering, use an icon label if there are children (implying the button has text) button just an icon if not
  return /* @ts-ignore */React.createElement(Container, __assign({}, containerProps), children ? React.createElement(My.Label, {
    colors: colors,
    disabled: !hasLink,
    iconSize: iconSize,
    className: cls.name(className),
    reverse: reverse,
    icon: icon
  }, children) : React.createElement(My.Body, {
    disabled: disabled,
    colors: colors,
    className: cls.name(className)
  }, icon));
};
IconLink.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;